// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"c2a08078","287":"11a8ba54","495":"c93f17e4","647":"4e9a404f","654":"43e33978","669":"ef5d4ba3"}[chunkId] + ".chunk.css";
};